var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ManagementPage", {
    attrs: { pageName: _vm.$t("StockManagement") },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function() {
          return [
            _c("TableView", {
              attrs: { selectedMaterials: _vm.selectedMaterials },
              on: {
                "change-tab": function($event) {
                  return _vm.changeTab($event)
                },
                "open-create-material-form": function($event) {
                  _vm.selectedMaterials = {}
                },
                "clear-selected-item": function($event) {
                  _vm.selectedMaterials = null
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "right",
        fn: function() {
          return [
            _c("material", {
              attrs: {
                selectedMaterials: _vm.selectedMaterials,
                activeTabMaterialFamily: _vm.activeTabMaterialFamily
              },
              on: {
                "clear-selected-item": function($event) {
                  _vm.selectedMaterials = null
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-390e0c91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-390e0c91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/StockView.vue
// module id = null
// module chunks = 